import { Typography } from "@mui/material";
import { BaseModuleSubtypeResponse } from "../../../../../../types/actionModule/baseModuleSubtype";
import { TextAnswerSubtypeDataModel } from "../../../../../../types/actionModule/subtypes/textAnswerModels";

interface Props {
    subtype: BaseModuleSubtypeResponse;
    subtypeData: TextAnswerSubtypeDataModel;
}

export default function TextAnswerSubtypeSummary(props: Props) {
    return <Typography textOverflow={"ellipsis"}>{props.subtypeData.textAnswer}</Typography>
}
